import { render } from "./nameIdSelector.vue?vue&type=template&id=385c0f70&scoped=true&ts=true"
import script from "./nameIdSelector.vue?vue&type=script&lang=ts"
export * from "./nameIdSelector.vue?vue&type=script&lang=ts"

import "./nameIdSelector.vue?vue&type=style&index=0&id=385c0f70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385c0f70"]])

export default __exports__